import $ from "jquery";

$(function () {

  /* Navigation dropdown functionality */
    $(window).on('resize',function () {
      if ($(window).width() < 1200) { 
        $(".header-dropdown").removeClass("open").slideUp('slow');
        $(".header-nav li.active").removeClass("active");
        $('.dropdown-masked').css('box-shadow','none');
      } else {
        $("body").removeClass("pushy-open-right");
		    $('.menu-btn i').removeClass('fa-times').addClass('fas fa-bars')
      }
    });
    
    $(".header-nav .nav-link, .header-search .nav-link").on("click", function (event) {
        event.preventDefault();
        var currentClass = $(this).data("link");
        if ($("div." + currentClass).hasClass("open")) {
        $("div." + currentClass).stop(true, false).removeClass("open").slideUp('slow');
          $(".header-nav li.active").removeClass("active");
          $(".header-search").removeClass("active");
          $('.dropdown-masked').css({
            'box-shadow':'none',
            'transition': 'box-shadow 100ms'
          }
          
          );
        } else {
          $("div." + currentClass)
            .stop(true, false)
            .slideDown('slow')
            .addClass("open")
            .siblings()
            .removeClass("open");
          $("div." + currentClass)
            .siblings(".header-dropdown")
            .stop(true, false)
            .slideUp('slow');
            $(".header-nav li.active").removeClass("active");
            var $parent = $(this).parent();
            $parent.addClass("active");
            $('.dropdown-masked').css({
              'box-shadow': '0 100vh 0 100vh rgb(0 0 0 / 50%), 0 5px 15px rgba(0,0,0,0.3)'
            });
        } 
    });

    $('main').on('click',function() {
      	$(".header-dropdown").removeClass("open").slideUp('slow');
        $(".header-nav li.active").removeClass("active");
        $(".header-search").removeClass("active"); 
        $('.dropdown-masked').css('box-shadow','none');
    });

    /* Social Sticky Buttons Functionality */
    $('.cta-item-1').hover(function() {
      	$('.cta-item-1').toggleClass('active')
    });
    $('.cta-item-2').hover(function() {
      	$('.cta-item-2').toggleClass('active')
    });
    $('.cta-item-3').hover(function() {
        $('.cta-item-3').toggleClass('active')
    });


    //Hamburger Menu toggle icon
    $('.menu-btn').on('click',function(){
      if($('.menu-btn i').hasClass('fas fa-bars')){
        	$('.menu-btn i').removeClass('fas fa-bars').addClass('fas fa-times');
      }
      else if(/Edge/.test(navigator.userAgent)) {
        if($('.menu-btn i').hasClass('fa-bars fas')){
        	  $('.menu-btn i').removeClass('fa-bars fas').addClass('fa-times fas');
        }
      }else{
        	$('.menu-btn i').removeClass('fas fa-times').addClass('fas fa-bars')
      }
    });
    
    //Numbers Element Last Child Border CSS
    var lastElement = $(".numbers-element").last();
    lastElement.last().css("border-right","0");
    
});

